import $ from 'jquery';

$(() => {
	console.log('Ready');

	$.getScript('https://keaz.ru/landing/captcha.js', () => {
		$('.cookie__button').on('click', () => {
			$('.cookie').removeClass('is-active');
		});

		$('.js-register-to-event').on('submit', function (_e) {
			_e.preventDefault();
			window.ym(87988635, 'reachGoal', 'REGISTRATION');

			const PATTERN_EMAIL = '[\\w\\-\\.\\_]+@([\\w\\-]+\\.)+[\\w\\-]+';

			const errorClass   = 'registration__input_error';
			const successClass = 'is-success';

			const errorMessagesForFolders = {
				fio    : 'Неправильное значение ФИО.',
				phone  : 'Неправильное значение телефона.',
				email  : 'Неправильное значение электронной почты.',
				company: 'Неправильное значение названия компании.',
				post   : 'Неправильное значение вашей должности.',
			};

			const form      = $(this);
			const wrapper   = $('.js-wrapper');
			const errorsBox = $('.js-errors-box');

			errorsBox.empty();

			const setErrorClass     = function (_nameOfFolder) {
				form.find('[name="' + _nameOfFolder + '"]').addClass(errorClass);
			};
			const removeErrorClass  = function (_nameOfFolder) {
				form.find('[name="' + _nameOfFolder + '"]').removeClass(errorClass);
			};
			const setErrorToFolders = function (_folders) {
				for (const indexFolder in _folders) {
					setErrorClass(_folders[indexFolder]);
				}
			};

			const insertMessagesToErrorsBox = (_errorMessages) => {
				for (let index in _errorMessages) {
					const p     = document.createElement('p');
					p.innerText = _errorMessages[index];
					errorsBox.append(p);
				}
			};

			const setErrorMessagesToFolder = (_nameFolder) => {
				setErrorClass(_nameFolder);
				errorFolders.push(_nameFolder);
				errorMessages.push(errorMessagesForFolders[_nameFolder]);
				form.find('[name="' + _nameFolder + '"]');
			};

			const errorFolders       = [];
			const errorMessages      = [];
			const serializedFormData = $(this).serializeArray();

			serializedFormData.find((_element)=> {
				const nameFolder = _element.name;
				if (errorMessagesForFolders[nameFolder]){
					const valueOfFolder = _element.value;
					removeErrorClass(nameFolder);
					if (valueOfFolder.trim().length) {
						return;
					}
					setErrorMessagesToFolder(nameFolder);
				}
			})

			if (errorMessages.length || errorFolders.length) {
				insertMessagesToErrorsBox(errorMessages);
				setErrorToFolders(errorFolders);
				return;
			}

			window.keazCaptchaService(form.attr('action'), form[0])
				  .then((_result) => {
					  wrapper.addClass(successClass);
					  if (_result.title) {
						  $('.js-form-title').text(_result.title);
					  }
					  if (_result.messages) {
						  $('.js-form-text').html(_result.messages.join('<br>'));
					  }
				  })
				  .catch((_errorResult) => insertMessagesToErrorsBox(_errorResult));
		});

		$('.js-registration-link').click(() => {
			$('html, body').animate({
				scrollTop: $('#registration').offset().top,
			}, 600);
		});
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js